"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_FILE_NAME = void 0;
exports.ENTITY_FILE_NAME = 'entity.json';
//# sourceMappingURL=Constants.js.map